import Vue from 'vue';
import axios from 'axios';

export async function FetchProblems({ commit }) {
  commit('cleanErrors');
  await Vue.axios({
    method: 'GET',
    url: `/problem/`,
  })
    .then((response) => {
      commit('setProblemList', { data: response.data });
    })
    .catch((error) => {
      commit('error', error);
    });
}

export async function FetchCauses({ commit }, problemId) {
  commit('cleanErrors');
  await Vue.axios({
    method: 'GET',
    url: `/problem/${problemId}/get_actions/`,
  })
    .then((response) => {
      commit('setCauseList', response.data);
    })
    .catch((error) => {
      commit('error', error);
    });
}

export async function FetchChanges({ commit }, causes) {
  commit('cleanErrors');
  await Vue.axios({
    method: 'POST',
    url: `/action/set_selection/`,
    data: {
      actions: causes,
    },
  })
    .then((response) => {
      commit('setChangeList', response.data);
    })
    .catch((error) => {
      commit('error', error);
    });
}

export async function FetchSkills({ commit }, changes) {
  commit('cleanErrors');
  await Vue.axios({
    method: 'POST',
    url: `/change/set_selection/`,
    data: {
      changes: changes,
    },
  })
    .then((response) => {
      commit('setSkillList', response.data);
    })
    .catch((error) => {
      commit('error', error);
    });
}

export async function FetchSkillDescription({ commit }, skillId) {
  commit('cleanErrors');
  await Vue.axios({
    method: 'GET',
    url: `/parent_skill/${skillId}/long_description/`,
  })
    .then((response) => {
      commit('setSkillDescription', response.data);
    })
    .catch((error) => {
      commit('error', error);
    });
}

export async function CreateNewConfiguration({ commit }, data) {
  commit('cleanErrors');
  try {
    const { data: response } = await axios.post(`/problem/${data.problem}/save_configuration/`, {
      ...data,
    });
    commit('setConfiguration', response);
  } catch (error) {
    commit('error', error);
    throw {
      error,
      info: '[Error]: Problem trying save the configuration to antecedents and consequents',
    };
  }
}

export async function FetchConfig({ commit }, parentId) {
  try {
    const { data } = await axios.get(`/parent/${parentId}/get_saved_configurations/`);
    commit('setConfigList', data);
  } catch (error) {
    commit('error', error);
    throw new Error('Ups!, i have an error when triying fetch the configuration saved...');
  }
}

export async function FetchTips({ commit }, problemId) {
  commit('cleanErrors');
  await Vue.axios({
    method: 'GET',
    url: `/problem/${problemId}/get_tips/`,
  })
    .then((response) => {
      commit('setTipsList', response.data);
    })
    .catch((error) => {
      commit('error', error);
    });
}

export async function FetchSkillsTips({ commit }, tip) {
  commit('cleanErrors');
  await Vue.axios({
    method: 'GET',
    url: `/tip/${tip}/get_skills/`,
  })
    .then((response) => {
      commit('setSkillTipsList', response.data);
    })
    .catch((error) => {
      commit('error', error);
    });
}

export async function fetchPopupsToTips({ commit }) {
  try {
    const { data } = await axios.get('/pop/problem_pop');
    commit('setInfoPopup', data);
  } catch (error) {
    throw new Error('[Action] Problems to try fetch the info to popups');
  }
}

export function updateChangesByCategory({ commit }, data) {
  try {
    commit('setChangesByCategory', data);
  } catch (error) {
    throw new Error('[Action] Error updating category.');
  }
}

export async function deleteProblemSolving({ commit }, { parentId, problemId }) {
  try {
    await axios({
      url: `/parent/${parentId}/delete_saved_configuration/`,
      method: 'DELETE',
      data: { saved_configuration_id: problemId },
    });
    commit('deleteProblemSaved', problemId);
  } catch (error) {
    throw { message: '[Q&T]: Error while deleting the record, try again later...', error };
  }
}
